import api from '../../models/services'
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      isLoad: true,
      countLoad: 0,
    }
  },
  methods: {
    goTo(path) {
      if (path !== '' && path !== this.$router.path) {
        if (window.matchMedia('(max-width: 767px)').matches) {
          this.$store.state.data_sidebartype = 'mini-sidebar'
          // eslint-disable-next-line no-undef
          $('#main-wrapper').removeClass('show-sidebar')
        }
        // this.$router.push(path).catch(() => { })
        // window.location = path
      }
    },
    getMenus() {
      api.getMenuList(
        this.$store.state.URLHost,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.token}`,
          },
        },
        (result) => {
          if (result.response === true) {
            this.$store.state.menu_data = result.data.menus
            this.isLoad = false
          } else {
            setTimeout(() => {
              if (sessionStorage.token) {
                location.reload()
              } else {
                if (this.countLoad < 3) {
                  this.countLoad++
                  this.getMenus()
                } else {
                  Swal.fire({
                    title: 'Get Menus ' + result.message,
                    text:
                      'There is a problem with your user data, would you like to log out ?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#F43131',
                    confirmButtonText: 'Logout',
                    cancelButtonText: 'Again',
                    reverseButtons: true,
                    customClass: 'Custom_Cancel',
                  }).then((result) => {
                    if (result.isConfirmed) {
                      localStorage.clear()
                      sessionStorage.clear()
                      this.$store.state.user = undefined
                      window.location.replace('/login')
                    } else {
                      location.reload()
                    }
                  })
                }
              }
            }, 1000)
          }
        },
        (error) => {
          if (error.message === 'Network Error') {
            this.alert_msg(
              'error',
              'Get Menus',
              'The menu could not be retrieved because ' + error.message
            )
            localStorage.clear()
            sessionStorage.clear()
            this.$store.state.user = undefined
            this.$router.push('/login')
          } else {
            if (this.countLoad < 3) {
              this.countLoad++
              this.getMenus()
            }
          }
        }
      )
    },
  },
  mounted() {
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      $('#sidebarnav').collapse({
        toggle: true,
      })
      if (sessionStorage.token) {
        this.getMenus()
      }
    }, 200)
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/slider.js